const sanitize = (input, options = {}) => {
  const allowedTags = new Set(options.allowedTags ?? [])
  const allowedAttributes = options.allowedAttributes ?? {}

  return String(input ?? '')
    .replace(/<!DOCTYPE[^>]*>/gi, '')
    .replace(/<!--([\s\S]*?)-->/g, '')
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, '')
    .replace(/<\/?\s*([a-z0-9-]+)([^>]*)>/gi, (match, tagName, attributes) => {
      const normalizedTag = tagName.toLowerCase()
      if (!allowedTags.has(normalizedTag)) {
        return ''
      }

      const allowed = new Set([...(allowedAttributes['*'] ?? []), ...(allowedAttributes[normalizedTag] ?? [])])
      const safeAttributes = (attributes ?? '')
        .trim()
        .split(/\s+/)
        .filter((attribute) => {
          if (!attribute) {
            return false
          }
          const [name] = attribute.split('=')
          return allowed.has((name ?? '').toLowerCase())
        })
        .join(' ')

      if (!safeAttributes) {
        return `<${match.startsWith('</') ? '/' : ''}${normalizedTag}>`
      }

      return `<${match.startsWith('</') ? '/' : ''}${normalizedTag} ${safeAttributes}>`
    })
}

sanitize.default = sanitize

export default sanitize
